import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import { initLenis } from "@/lib/lenis";
import { LanguageProvider } from "@/lib/i18n";

function App() {
  useEffect(() => initLenis(), []);

  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-center" />
      </LanguageProvider>
    </div>
  );
}

export default App;
